import { toast } from "react-toastify";

export const processPayment = ({ userId, amount, purpose, email, phone, name }) => {
  console.log(phone)
  return new Promise(async (resolve, reject) => {
    try {
      // Input validation
      if (!userId || typeof userId !== "string") {
        toast.error("Invalid user ID.");
        return reject(new Error("Invalid user ID"));
      }
      if (isNaN(amount) || amount <= 0) {
        toast.error("Invalid payment amount.");
        return reject(new Error("Invalid amount"));
      }
      if (!purpose || typeof purpose !== "string") {
        toast.error("Invalid payment purpose.");
        return reject(new Error("Invalid purpose"));
      }
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        toast.error("Invalid email address.");
        return reject(new Error("Invalid email"));
      }
      if (!phone || !/^\+91\d{10}$/.test(phone)) {
        toast.error("Invalid phone number. Expected format: +91XXXXXXXXXX");
        return reject(new Error("Invalid phone number"));
      }
      if (!name || typeof name !== "string") {
        toast.error("Invalid name.");
        return reject(new Error("Invalid name"));
      }

      // Check Razorpay SDK
      if (!window.Razorpay) {
        toast.error("Payment gateway not loaded. Please check your connection.");
        return reject(new Error("Razorpay SDK not loaded"));
      }

      const functionURL = "https://createorder-qwfnnmalla-uc.a.run.app";

      // Convert amount to paise without rounding
      const amountInPaise = Math.round(amount * 100); // Multiply first, then round
      console.log("Original amount:", amount, "Amount in paise:", amountInPaise);

      const response = await fetch(functionURL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId,
          amount: amountInPaise,
          currency: "INR",
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to create order: ${response.status}`);
      }

      const orderData = await response.json();
      if (!orderData.id) {
        throw new Error("Invalid order data received.");
      }

      console.log("✅ Order Created:", orderData);

      // Razorpay options
      const options = {
        // key: "rzp_live_5R2gm66XuUMXis", // Replace with production key in production
        key: "rzp_live_sid2QL0wbY5mCQ", // original
        amount: orderData.amount, // Should be exactly amountInPaise
        currency: orderData.currency,
        order_id: orderData.id,
        name: "JBSM Enterprises",
        description: purpose,
        handler: async function (paymentResponse) {
          console.log("✅ Payment Success:", paymentResponse);
          if (paymentResponse.razorpay_payment_id) {
            toast.success("Payment completed successfully!");
            resolve(paymentResponse);
          } else {
            toast.error("Payment verification failed.");
            reject(new Error("Payment verification failed"));
          }
        },
        prefill: {
          name,
          email,
          contact: phone,
        },
        theme: { color: "#3399cc" },
        modal: {
          ondismiss: () => {
            console.warn("Payment modal closed by user.");
            toast.warn("Payment cancelled by user.");
            reject(new Error("Payment cancelled by user"));
          },
        },
        retry: {
          enabled: true,
          max_count: 3,
        },
        timeout: 300, // 5 minutes timeout
      };

      const razor = new window.Razorpay(options);

      razor.on("payment.failed", (response) => {
        console.error("❌ Payment Failed:", response.error);
        toast.error(`Payment Failed: ${response.error.description}`);
        reject(new Error(response.error.description));
      });

      razor.on("payment.cancel", () => {
        console.warn("Payment cancelled externally.");
        toast.warn("Payment was cancelled.");
        reject(new Error("Payment cancelled"));
      });

      razor.open();
    } catch (error) {
      console.error("Payment error:", error);
      toast.error(`Payment failed: ${error.message}`);
      reject(error);
    }
  });
};
